import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { deleteSMSOrWebRequest, getWaitingSMSOrWebRequests } from "../store/api/ComplaintsAPI";
import { CheckSquare } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { useEffect, useState } from "react";
import { setDialog } from "../store/api/Modals";
import ModalAddNewComplaint from "../Components/ModalAddNewComplaint";
import { setErrorDialog } from "../../store/api/CommonFunctions";

export default function Complaints_RequestBySMSOrWeb() {
    const filterData = useSelector(state => state.ComplaintsReducer.waitingSMSOrWebRequestsFilters)??{};
    
    const [modalComplaint, setModalComplaint] = useState({ show: false });
    const dispatch = useDispatch();
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "PCreationDate", colTitle: "تاریخ درخواست", showOnMobile: true },
        { colName: "CustomerName", colTitle: "نام مشتری", showOnMobile: true },
        { colName: "NationalCode", colTitle: "کد ملی" },
        { colName: "CustomerMobile", colTitle: "ش. همراه مشتری" },
        { colName: "CustomerTel", colTitle: "ش. تلفن مشتری" },
        { colName: "Email", colTitle: "Email" },
        { colName: "CustomerAddress", colTitle: "نشانی مشتری" },
        { colName: "ShopName", colTitle: "نام فروشگاه" },
        { colName: "SerialNumber", colTitle: "سریال محصول" },
        { colName: "ProductName", colTitle: "نام/نوع محصول" },
        { colName: "ProductModel", colTitle: "مدل محصول" },
        { colName: "PGuaranteeStartDate", colTitle: "آغاز گارانتی" },
        { colName: "PGuaranteeEndDate", colTitle: "پایان گارانتی" },
        { colName: "PRegisterType", colTitle: "نحوه درخواست" },
        { colName: "Title", colTitle: "عنوان شکایت/درخواست", colType: "string", maxTextLength: 50, hasTooltip: true },
        { colName: "Body", colTitle: "متن شکایت/درخواست", colType: "string", maxTextLength: 50, hasTooltip: true },
        { colName: "TypeStr", colTitle: "نوع درخواست" }
    ]
    const tableRowButtons = [

        {
            title: "ثبت عملیات",
            type: "common",
            icon: <CheckSquare size={20} color="#0e44b1ff" className="rowBtn" />,
            className: " group-Btn-smalll",
            onclick: doAction,
            showCondition:(item)=> !item.NeedReply
        },
        {
            title: "حذف درخواست", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف درخواست',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteRequest(item)
                }))
            }
        }

    ]
    function deleteRequest(row) {
        const onDelete = (res)=>{
            if(res.Error)
            {
                setErrorDialog(dispatch,res.Error,"حذف ردیف");
            }
            else if(res.Data)
            {
                search(filterData);
            }
        }
        deleteSMSOrWebRequest(row.ID, onDelete);
    }
    function doAction(row) {
        if (Number(row.Type) === 0) {
            setModalComplaint({
                show: true,
                Title: row.Title,
                Body: row.Body,
                CustomerID: row.CustomerID,
                ProductID: row.ProductID,
                ProductSerial: row.SerialNumber,
                SMSOrWebRequestID:row.ID,
                onSubmit:()=>search(filterData)
            })
        }
    }
    function search(data) {
        dispatch(getWaitingSMSOrWebRequests(data));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        search();
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <ModalAddNewComplaint popData={modalComplaint} setPopData={setModalComplaint} />
            <Card>
                <Card.Header className="card-header headerStyle">
                    <FontAwesomeIcon icon={faHeadset} size="lg" />&nbsp;
                    صدای مشتری</Card.Header>
                <Card.Body className="card-body bodyStyle" style={{ textAlign: "right" }}>
                    {/* <Button className="group-Btn-large" onClick={()=>search()}><List size={20}/>&nbsp;جستجو</Button> */}
                    <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} reducerName="ComplaintsReducer" objectName="waitingSMSOrWebRequests" maxHeight={500} style={{ whiteSpace: "nowrap" }} />
                </Card.Body>
            </Card>
        </div>
    )
}